
import {ActionType, reducerStoreType, userStateType} from "./types";

const defaultState = {
    userList: [],
    userFilters: {
        storeId: -1,
        name: '',
        loginNo: ''
    },
    total: 0,
    currentPage: 1,
    recordsPerPage: 5
}


const users = (state: userStateType = defaultState, action: ActionType<any>) => {
    switch (action.type) {
        case 'SET_USER_LIST':
            return {
                ...state,
                userList: action.payload.data.list,
                ...action.payload.pageParams
            }
        case 'USER_FILTER_CHANGE':
            return {
                ...state,
                userFilters: {
                    ...state.userFilters,
                    [action.payload.name]: action.payload.value
                }
            }
        case 'USER_FILTER_CLEAR':
            return {
                ...state,
                userFilters: {
                    storeId: -1,
                    name: '',
                    loginNo: ''
                }
            }
        case 'INIT_RECORDS_PER_PAGE':
            return {
                ...state,
                recordsPerPage: action.payload.recordsPerPage
            }
        case 'LOGOUT':
            return {
                ...state,
                userFilters: {
                    storeId: -1,
                    name: '',
                    loginNo: ''
                },
            }
        default:
            return state;
    }
}

export const userPageParams = (state:reducerStoreType) => ({
    currentPage: state.users.currentPage,
    recordsPerPage: state.users.recordsPerPage
})
export const userFilters = (state:reducerStoreType) => (state.users.userFilters)
export default users